export default "__VITE_ASSET__B3EX06kB__"